import React from "react";
import { Row, Col } from 'react-bootstrap';
/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import Heading2 from '../titles/Heading2';
import GenericParagraph from '../paragraphs/Paragraph';

class TabDetails extends React.Component {       
    render () {       
        var backgroundImage = {
            backgroundImage: 'url(../images/' + this.props.content.contentImage + ')'
        }
        return (
            <Row>
                <Col md={3}>
                    <div className="gtco-video gtco-bg" style={ backgroundImage }>
                        
                    </div>
                </Col>
                <Col md={9}>
                    <Heading2 title={ this.props.content.contentHeading } />
                    <GenericParagraph text={ this.props.content.cotentParagraph } />
                    <Row>
                        <Col md={12} className="techs">
                            <Heading2 title={ this.props.content.contentHeadingTech } />
                            <ul>
                                { typeof this.props.content.techList !== 'undefined' &&
                                    this.props.content.techList.map (value => <li data={value} key={value.toString()}>{value}</li>)
                                }
                            </ul>
                        </Col>
                    </Row>                    
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(TabDetails);




// WEBPACK FOOTER //
// ./src/components/tabs/tab-content.jsx